import React, {Component} from 'react';
import {YesNoModal} from "../../elements/YesNoModal";
import {FaIcon} from "../../FaIcon";
import { withTranslation } from 'react-i18next';


class CredentialRowClass extends Component {
    constructor(props) {
        super(props);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleRemove() {
        this.props.onRemove(this.props.credential.id);
    }

    render() {
        const { credential, t, i18n } = this.props;
        const label = credential.label || t('credential_row.unknown_label');
        const createdAt = credential.created_at
            ? new Date(credential.created_at).toLocaleDateString(i18n.language)
            : '-';

        return (
            <tr>
                <td>{label}</td>
                <td>{credential.ad_accounts_count}</td>
                <td>{createdAt}</td>
                <td>
                    <YesNoModal onYesAnswer={this.handleRemove}
                                title={t('credential_row.delete_title')}
                                message={t('credential_row.delete_message')}
                                question={t('credential_row.delete_question')}
                                buttonClassName={""}
                                buttonText={""}
                                buttonTitle={t('credential_row.delete_button_title')}
                                buttonIconName={"trash"}
                                isSaving={this.props.isSaving}
                    />
                </td>
            </tr>
        );
    }
}

export const CredentialRow = withTranslation()(CredentialRowClass);
export default CredentialRow;
